import { render, staticRenderFns } from "./delete-dialog.vue?vue&type=template&id=4613e8d2&"
import script from "./delete-dialog.vue?vue&type=script&lang=js&"
export * from "./delete-dialog.vue?vue&type=script&lang=js&"
import style0 from "./delete-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QAvatar,QIcon,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QAvatar,QIcon,QBtn})
